<template>
  <div
    class="card"
    :style="{
      '--c': itemData.color,
    }"
    :class="{
      fixed: itemData.is_fixed,
    }"
    @click="emit('show')"
    :data-marker-id="itemData.id"
  >
    <div class="card-header">
      <strong class="cat-title">{{ itemData.categoryTitle }}</strong>
      <strong>{{ itemData.title }}</strong>

      <div class="top-right">
        <button v-if="!itemData.is_fixed" @click="emit('fix')">Korras?</button>
        <div v-else>Korras</div>
      </div>
    </div>

    <p v-if="itemData.description">{{ itemData.description }}</p>

    <img v-if="itemData.image" :src="itemData.image" loading="lazy" />

    <div class="card-footer">
      <small>{{ itemData.county }}</small>
      <small>{{ formattedDate }}</small>
    </div>
  </div>
</template>

<style scoped>
.card {
  margin-bottom: 3em;

  box-sizing: border-box;
  padding: 1em;

  margin-top: 0;
  margin-bottom: 2.5em;
  margin-left: 1rem;
  margin-right: 1rem;

  border-radius: 6px;
  box-shadow: 0 1px #cdd4db, 0 -1px #e3e9ed;

  cursor: pointer;

  background-color: var(--lightest);

  display: flex;
  flex-direction: column;
}

.card.fixed {
  background-color: #deeaeb;
}

.small .card {
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: 0;
  margin-right: 1em;

  min-width: 12em;
}

.card * {
  pointer-events: none;
  user-select: none;
}

.card img {
  max-width: 100%;
  object-fit: contain;

  margin-top: 5px;
  margin-bottom: 5px;
}

.small .card img {
  max-width: 60vw;
  max-height: 60%;
}

.card-header {
  width: 100%;
  display: flex;
  flex-direction: column;

  position: relative;
}

.card-header .top-right {
  position: absolute;
  top: 0;
  right: 0;
}

.small .card-header {
  /*  flex-direction: column-reverse;*/
  gap: 0.25em;
}

.small .card-header .top-right {
  position: static;

  display: flex;
  justify-content: flex-end;
}

.top-right button {
  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;

  pointer-events: all;
  z-index: 9;

  border-radius: 1.5em;
  padding: 0.5em;
  border: none;

  background-color: var(--light);
  color: var(--fixed-green);
  font-weight: 700;

  transition: 150ms ease;

  cursor: pointer;
  user-select: none;
}

.top-right button:hover {
  background-color: var(--hover-background-color);
}

.top-right button:disabled {
  background-color: var(--gray);
}

.top-right > div {
  background-color: var(--fixed-green);
  color: white;
  font-size: 0.8em;
  font-weight: 700;
  border-radius: 1.5em;
  padding: 0.5em;

  pointer-events: none;
}

.card strong {
  line-height: 1.25;
  font-size: 1.75em;
}

.small .card strong {
  font-size: 1.25em;
}

.cat-title {
  display: grid;
  grid-template-columns: 27px 1fr;
  align-items: center;
  color: var(--c);
}

.cat-title::before {
  content: "";

  width: 20px;
  height: 20px;

  box-sizing: border-box;
  background-color: white;
  border: 6px solid var(--c);
  border-radius: 50%;
  margin-bottom: 0.1em;
}

.card p {
  white-space: pre-wrap;
  line-height: 1.25;
  font-weight: 300;

  margin: 0.75em 0 !important;

  text-overflow: ellipsis;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  pointer-events: all;
}

.card-footer {
  margin-top: 0.45em;

  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-footer small {
  color: var(--gray);
  font-size: 0.7em;
}
</style>

<script setup>
import { toRef, computed } from "vue";

const props = defineProps({
  item: Object,
});

const emit = defineEmits(["show", "fix"]);

const itemData = toRef(props, "item");

const formattedDate = computed(() => {
  return new Date(itemData.value.created).toLocaleTimeString("et", {
    hour: "2-digit",
    minute: "2-digit",
    weekday: "short",
    day: "numeric",
    month: "long",
  });
});

// console.log(itemData.value);
</script>
